import { buildLoginUrl, classNames } from "utils/helpers"
import { useMessages } from "../language/language"
import TopNav from "../components/top-nav"
import "./student-not-playing-layout.less"
import "../../flags.less"
import DefaultTopNavLinks from "../frames/top-nav-default-links"
import { PropsWithChildren } from "react"
import ProfilePicture from "../components/profile-picture"
import { Link } from "react-router-dom"
import NotPlayingBackground from "../components/not-playing-background"
import { usePlayState } from "play/hooks/use-play-state"
import EmailUndeliverableAlert from "play/components/email-undeliverable-alert"

interface Props {
  className?: string
}

export default function StudentNotPlayingLayout(
  props: PropsWithChildren<Props>
) {
  const { children } = props

  return (
    <div className={classNames("student-not-playing-layout", props.className)}>
      <TopNav>
        <DefaultTopNavLinks />
        <LoginUserInfo />
      </TopNav>
      <div className="logo"></div>
      <div className="not-logged-in-content">
        <NotPlayingBackground />
        <EmailUndeliverableAlert linkToProfile />
        {children}
      </div>
    </div>
  )
}

function LoginUserInfo() {
  const { loggedUser, fullName } = usePlayState()
  const isTeacher = loggedUser?.isTeacher === true
  const isLogged = !!loggedUser
  const profilePictureUrl = loggedUser?.profilePictureUrl
  const msg = useMessages()

  if (isLogged) {
    const uiName = isTeacher ? msg.userIsTeacher(fullName!) : fullName

    return (
      <Link className="login-user-info" to="/profile">
        <ProfilePicture profilePictureUrl={profilePictureUrl} size="Menu" />
        <div className="full-name">{uiName}</div>
      </Link>
    )
  } else {
    return (
      <div className="login-user-info">
        <a href={buildLoginUrl()}>{msg.loginPage_logIn}</a>
        {/*<a href={buildRegisterStudentUrl()}>{msg.loginPage_register}</a>  */}
      </div>
    )
  }
}
